<template>
    <svg
        fill="none"
        height="18"
        viewBox="0 0 24 18"
        width="24"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.9999 7.66317H18.8716C18.6069 5.28361 19.2067 2.24358 23.9999 2.24358C23.9999 0.555939 23.9999 0.0652047 23.9999 0.0617828C14.0311 0.0617828 13.7249 5.0077 13.7249 7.66322V17.9382H23.9999V7.66317Z"
            fill="currentColor" />
        <path
            d="M10.275 7.66317H5.14697C4.88227 5.28357 5.48198 2.24353 10.275 2.24353C10.275 0.555893 10.275 0.0651589 10.275 0.0617371C0.306422 0.0617839 0 5.00771 0 7.66317V17.9382H10.275V7.66317Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
